<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'almacen' }">{{
                $t("almacen")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("hacerInventario") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12" v-if="accionInventario">
        <div class="card">
          <div class="text-right">
            <strong>{{ $t("seleccionarTodas") }} </strong
            ><input v-model="xTodos" @change="marcarTodos()" type="checkbox" />
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>Nombre</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :class="{ 'table-success': xEtiqueta.check }"
                  v-for="xEtiqueta in listEtiquetas"
                >
                  <td>{{ xEtiqueta.name }}</td>
                  <td align="center">
                    <input v-model="xEtiqueta.check" type="checkbox" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="width: 30%">
            <button @click="saveInventario" class="btn btn-success">
              <i class="fa fa-check-square"></i>
              {{ $t("realizarInventario") }}
            </button>
            <router-link
              :to="{
                name: 'historial-almacen',
                params: { idBusiness: idBusiness },
              }"
            >
              <button class="btn btn-danger">
                <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="col-md-12 ml-0">
        <div class="card" style="padding-top:30px;margin-bottom:15px;">
          <div class="row">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert">
                {{ $t("loSentimosSuNegocioNoTieneContratadoEsteModulo") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Switch,
  Radio,
  Loading,
} from "element-ui";

import swal from "sweetalert2";

export default {
  name: "ControlInventario",
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Radio.name]: Radio,
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });

    this.$store.dispatch("setNameRoute", "Hacer Inventario");
    this.getConfigTpv();
    this.getEtiquetas();
  },
  data() {
    return {
      idBusiness: this.$route.params.idBusiness,

      listEtiquetas: [],
      xTodos: false,
      accionInventario: true,
    };
  },
  methods: {
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 48,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.accionInventario = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    marcarTodos() {
      for (let i = 0; i < this.listEtiquetas.length; i++) {
        if (!this.xTodos) {
          this.listEtiquetas[i].check = false;
        } else {
          this.listEtiquetas[i].check = true;
        }
      }
    },

    getEtiquetas() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.listEtiquetas = [];

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            let categoryname = {
              name: vm.$t("sinCategoria"),
              id: 0,
              check: false,
            };

            vm.listEtiquetas.unshift(categoryname);

            for (let i = 0; i < response.data.result.length; i++) {
              let categoryname = {
                name: response.data.result[i].name,
                id: response.data.result[i].id,
                check: false,
              };

              vm.listEtiquetas.push(categoryname);
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    saveInventario() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        inventarioCompleto: this.xTodos,
        listEtiquetas: this.listEtiquetas,
      };

      let vm = this;
      let controller = "createInventario";
      this.axios
        .post(
          this.$store.getters.apiUrl + "almacen/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("inventarioRealizadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$router.push({
              name: "inventario",
              params: { query: response.data.result },
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}

.card {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/GestionAlmacen/ControlInventario.vue